import VuePortal from '@linusborg/vue-simple-portal';
import { createPinia, PiniaVuePlugin } from 'pinia';
import { install as VueMonacoEditorPlugin } from '@guolao/vue-monaco-editor';
import '@/plugins/chart-js';
import '@/plugins/error-handler';
import '@/plugins/font-awesome-icons';
import '@/plugins/swiper';

import autofocus from '@/plugins/autofocus';
import DataAttribute from '@/plugins/data-attribute';
import i18n from '@/plugins/i18n.ts';
import statistic from '@/plugins/statistic';
import dropbox from '@/plugins/dropbox';

export default (Vue, { store, config }) => {
    Vue.directive('autofocus', autofocus);
    Vue.use(DataAttribute);
    Vue.use(statistic, { store, config });
    Vue.use(VuePortal);
    Vue.use(VueMonacoEditorPlugin);
    Vue.use(dropbox, { config });

    Vue.use(PiniaVuePlugin);
    const pinia = createPinia();

    return { i18n, pinia };
};
